<template>
<div class="col-md-12" v-if="documents.length >= 0">

    <b-modal ref="modal-document-remarks" header-class="hidden">
        <template v-slot:default="{}">
            <div class="modal-body">
                <p class="m-b-xs"><strong>{{ __('document_number')}}:</strong> {{ modalRemarksDocument.document_number }}</p>
                <p class="m-b-xs"><strong>{{ __('status')}}:</strong>
                    <span class="label label-danger">{{ __('not_confirmed') }}</span>
                    <span v-show="modalRemarksDocument.substatus  == 'document_to_be_filled' "><i class="fas fa-file-alt"></i> {{ __('document_to_be_filled')}}</span>
                    <span v-show="modalRemarksDocument.substatus  == 'document_to_be_split_on_employees' "><i class="fas fa-user-check"></i> {{ __('document_to_be_split_on_employees')}}</span>
                    <span v-show="modalRemarksDocument.substatus  == 'document_to_be_split_for_controlling' "><i class="fas fa-coins"></i> {{ __('document_to_be_split_for_controlling')}}</span>
                    <span v-if="modalRemarksDocument.pl_ksef_information && modalRemarksDocument.pl_ksef_information.status != 'completed'" class="text-bold" :style="modalRemarksDocument.pl_ksef_information_style">e </span> <span v-if="modalRemarksDocument.pl_ksef_information && modalRemarksDocument.pl_ksef_information.status != 'completed'">{{modalRemarksDocument.pl_ksef_information_title}}</span>

                </p>
                <p class="m-b-xs"><strong>{{ __('remarks') }}: </strong>{{ modalRemarksDocument.remarks }}</p>
            </div>
        </template>
        <template v-slot:modal-footer="{close}">
            <div class="row">
                <div class="col-md-12">
                    <button type="button" class="btn btn-white" @click="close">{{ __('close')}}</button>
                </div>
            </div>
        </template>
    </b-modal>

    <div class="ibox form">
        <div class="ibox-title ibox-grey">
            <h4>{{ __(tableTitle) }}</h4>
            <button-open-help-modal :helpName="helpName"/>
        </div>
        <div class="ibox-content pb-0">
            <div class="scroll-table">
                <div class="row">
                    <div class="col-md-12">
                        <table-pagination v-if="paginate" :meta="meta"
                                @paginate:per-page="changePerPage"
                                @paginate:page="goToPage">
                        </table-pagination>
                        <label v-if="isNotPaidAlert"><input type="checkbox" :checked="showAlsoTimelyChecked"  @click="showAlsoTimely($event)"> {{ __('show_also_timely_documents')}}</label>
                    </div>
                </div>
                <div class="table-responsive text-nowrap">
                    <table class="table main-table documents" data-model="documents">
                        <thead>
                        <tr>
                            <th class="th-first">
                                <input type="checkbox" ref="check_all" @click="handleSelectAll">
                            </th>
                            <th>{{ __('document_date_short') }}</th>
                            <th v-show="multiple_contractors">{{ __('contractor')}}</th>
                            <th v-if="!isNotPaidAlert">{{ __('document_type') }}</th>
                            <th>{{ __('document_marking') }}</th>
                            <th class="text-right">{{ __('net_amount') }}</th>
                            <th class="text-right">{{ __('gross_amount') }}</th>
                            <th class="text-right">{{ __('document_balance') }}</th>
                            <th>{{ __('currency') }}</th>
                            <th>{{ __('exchange_rate') }}</th>
                            <th class="text-right">{{ __('balance_in_default_currency_short') + userInfo.default_currency.toUpperCase()}}</th>
                            <th v-if="show_due_date">{{ __('due_date_short') }}</th>
                            <th v-if="show_due_date" class=""> {{ __('payment_term_in_days_short')}}</th>
                            <th v-if="show_due_date && showRealPaymentInDays" class=""> {{ __('real_payment_in_days')}}</th>
                            <th v-if="show_due_date && showRealPaymentInDays" class="text-right">+/-</th>
                            <th class="th-before th-last text-right"></th>
                        </tr>
                        </thead>

                        <tbody class="document-line" v-for="(document, index) in documents">
                        <tr class="row-show document-info" @click="toggleDetails(index)" :class="{ 'row-even': index%2 === 1 }">
                            <td class="td-padding">
                                <input type="checkbox" :value="document.id" @change="handleDocumentSelect(document)" :checked="ids.includes(document.id)" :disabled="document.cash_register_id != null">
                            </td>
                            <td class="td-padding date">{{ document.date_issued }}</td>
                            <td class="td-padding text-wrap contractor-table-field wrap-text-inside-td" v-show="multiple_contractors">
                                <truncated-text :text="document.contractor" :max_length="55"/>
                            </td>
                            <td v-if="!isNotPaidAlert" class="td-padding">
                                <wrapped-text :text="__(document.document_type)" :line_max="20"/>
                            </td>
                            <td class="td-padding number"><truncated-text :text="document.document_number" :max_length="20"/></td>
                            <td class="td-padding text-right">
                                {{ document.formatted_net_amount }}
                            </td>
                            <td class="td-padding text-right">
                                {{ document.formatted_gross_amount }}
                            </td>
                            <td class="td-padding text-right">{{ document.formatted_balance }}</td>
                            <td class="td-padding currency">{{ document.currency }}</td>
                            <td class="td-padding">{{ document.document_exchange_rate_presentation }}</td>
                            <td class="td-padding text-right">{{ document.balance_in_default_currency}}</td>
                            <td v-if="show_due_date" class="td-padding">{{ document.due_date }}
                                <span v-if="document.due_dates.length > 1" class="label label-default" data-toggle="tooltip" data-placement="top" title="" :data-original-title="document.due_dates.join(';')">...</span></td>
                            <td v-if="show_due_date" class="td-padding">{{ document.payment_term_in_days }}</td>
                            <td v-if="show_due_date && showRealPaymentInDays && document.show_danger_real_payment_in_days == 1" class="td-padding">

                                <span class="label label-danger" data-toggle="tooltip" data-placement="top" title="">{{ document.real_payment_in_days }}</span>
                            </td>
                            <td v-else-if="show_due_date && showRealPaymentInDays" class="td-padding">
                                {{document.real_payment_in_days}}
                            </td>
                            <td
                                v-if="show_due_date && showRealPaymentInDays"
                                class="td-padding text-right"
                                :class="{
    'text-green': document.difference_real_payment_in_days_and_payment_term_in_days < 0,
    'text-red': document.difference_real_payment_in_days_and_payment_term_in_days > 0
  }"
                            >
                                {{ document.difference_real_payment_in_days_and_payment_term_in_days > 0 ?('+' + document.difference_real_payment_in_days_and_payment_term_in_days) :document.difference_real_payment_in_days_and_payment_term_in_days }}
                            </td>
                            <td class="text-right table-icons">

                                <span v-if="getPermission('perm_view_summaries_document_status')" class="label"
                                    :class="documentStatusLabel(document)"
                                      @click="showRemarks(document)"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    :title="document.type_group == 'own_documents' && document.status == 'rejected' ? __('cancelled') : __(document.status)"
                                    :data-original-title="document.type_group == 'own_documents' && document.status == 'rejected' ? __('cancelled') : __(document.status)"
                                >{{ document.type_group == 'own_documents' && document.status == 'rejected' ? 'A' : __(document.status).charAt(0) }}</span>

                                <a v-if="document.has_access_history" v-show="multiple_contractors"
                                   :href="document.history_url"
                                   :title="__('contractor_history')"
                                   :data-original-title="__('contractor_history')"
                                   data-toggle="tooltip"
                                   data-placement="top">
                                    <i class="fas fa-share"></i>
                                </a>

                                <a v-if="document.has_access_scan" v-show="document.scan_url"
                                   :href="document.scan_url"
                                   :title="__('download_file')"
                                   :data-original-title="__('download_file')"
                                   class="tooltip-more">
                                    <i class="fas fa-paperclip"></i>
                                </a>
                                <a v-if="document.has_access_pdf" v-show="document.pdf_url"
                                   :href="document.pdf_url"
                                   :title="__('download_file')"
                                   :data-original-title="__('download_file')"
                                   class="tooltip-more">
                                    <i class="fas fa-paperclip"></i>
                                </a>
                                <a v-if="document.type_group == 'own_documents' ? document.has_access_show_own : document.has_access_show_foreign"  :href="document.show_url + '?return=' + location"
                                   :title="__('show')"
                                   :data-original-title="__('show')"
                                   data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-eye"></i>
                                </a>

                                <a v-if="checkPermissionForDocumentToEdit(document)"   v-show="document.document_edition_enabled" :href="document.edit_url + '?return=' + location"

                                   :title=" __('edit')"
                                   :data-original-title="__('edit')"
                                   data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-pen"></i>
                                </a>

                                <i v-if="addEditPermission(document) && document.is_update_allowed===false"
                                   class="fa disabled-edit-icon fa-pen"
                                   :data-original-title="document.update_blocked_message"
                                   data-toggle="tooltip" data-placement="top"></i>


                            </td>
                        </tr>

                        <document-allocations
                                v-for="allocation in document.document_allocations"
                                v-show="showDetails === index"
                                @destroy="destroy(allocation)"
                                :allocation="allocation"
                                :key="allocation.id"
                                :multiple_contractors="multiple_contractors">
                        </document-allocations>

                        <allocations-for-document
                                v-for="allocation in document.allocations_for_documents"
                                v-show="showDetails === index"
                                @destroy="destroy(allocation)"
                                :allocation="allocation"
                                :key="allocation.id"
                                :multiple_contractors="multiple_contractors">
                        </allocations-for-document>

                        <operation-allocations
                                v-for="allocation in document.operation_allocations"
                                v-show="showDetails === index"
                                @destroy="destroy(allocation)"
                                :allocation="allocation"
                                :document="document"
                                :key="allocation.id"
                                :multiple_contractors="multiple_contractors">
                        </operation-allocations>

                        <document-corrections
                                v-for="correction in document.corrections"
                                v-show="showDetails === index"
                                @destroy="destroy(correction)"
                                :correction="correction"
                                :key="correction.id"
                                :multiple_contractors="multiple_contractors">
                        </document-corrections>

                        <tr class="document-allocations normal-wrap" v-show="showDetails === index && document.connection_list_title !== null" v-for="v in document.connection_list_title">
                            <td class="left-border" :colspan="multiple_contractors ? 11 : 11" v-html="v.title">
                            </td>
                            <td class="text-right table-icons">
                                <a v-if="v.check_is_visible == 0 && v.show_url && v.has_access_show != undefined && v.has_access_show" :href="v.show_url +'?&returnUrl=' + return_url"
                                   :title="__('show')"
                                   :data-original-title="__('show')"
                                   class="icon-delete" data-toggle="tooltip" data-placement="top" >
                                    <i class="fa fa-eye"></i>
                                </a>
                                <a v-if="v.check_is_visible != 0 && v.show_url && v.has_access_show != undefined && v.has_access_show"  @click="checkCanShow(v)"
                                   :title="__('show')"
                                   :data-original-title="__('show')"
                                   class="icon-delete" data-toggle="tooltip" data-placement="top" >
                                    <i class="fa fa-eye"></i>
                                </a>
                                <a v-if="(v.disabled_edit == undefined || v.disabled_edit == false) && v.check_is_visible == 0 && v.edit_url && v.has_access_edit != undefined && v.has_access_edit " :href="v.edit_url +'?&returnUrl=' + return_url"
                                   :title="__('edit')"
                                   :data-original-title="__('edit')"
                                   class="icon-delete" data-toggle="tooltip" data-placement="top" >
                                    <i class="fa fa-pen"></i>
                                </a>
                                <a v-if="(v.disabled_edit == undefined || v.disabled_edit == false) && v.check_is_visible != 0 && v.edit_url && v.has_access_edit != undefined && v.has_access_edit "
                                   @click="checkCanEdit(v)"
                                   :title="__('edit')"
                                   :data-original-title="__('edit')"
                                   class="icon-delete" data-toggle="tooltip" data-placement="top" >
                                    <i class="fa fa-pen"></i>
                                </a>
                                <a v-if="(v.disabled_edit != undefined && v.disabled_edit == true) && v.check_is_visible != 0 && v.edit_url && v.has_access_edit != undefined && v.has_access_edit"
                                   :title="__('cant_edit_operation_in_cash_register_in_other_department')"
                                   :data-original-title="__('cant_edit_operation_in_cash_register_in_other_department')"
                                   class="icon-delete" data-toggle="tooltip" data-placement="top" >
                                    <i class="fa fa-pen disabled-edit-icon"></i>
                                </a>
                                <a v-if="v.destroy_url && hasAccessToDestroy(v)" @click="destroy(v)"
                                   :title="__('delete')"
                                   :data-original-title="__('delete')"
                                   class="icon-delete" data-toggle="tooltip" data-placement="top" >
                                    <i class="fa fa-trash"></i>
                                </a>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table-pagination v-if="paginate" :meta="meta"
                                @paginate:per-page="changePerPage"
                                @paginate:page="goToPage">
                        </table-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-md-8" >
                    <bulk-action  v-if="allow_export == true && !contractorHistoryDocumentsExportDisabled" :url="bulkUrl" :table="tableType" :ids="bulkIds" param="document_id" :table_title="tableTitle" :data="bulkAdditionalData"></bulk-action>
                    <div v-if="allow_export == true && contractorHistoryDocumentsExportDisabled" >
                        <div>
                            {{ __('with_selected') }}:
                            <button data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle" disabled="">
                                {{ __('export') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 text-right">
                    <h3 class="m-b-xs" v-if="this.documents.length > 0 && this.hide_balance_in_default_currency_row !== true">{{ __('section_balance_in_default_currency') }}: <strong>{{ section_balance | money }} {{ userInfo.default_currency.toUpperCase() }}</strong></h3>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import events from '../../services/Events.js';
    import tooltips from '../../mixins/hasTooltips.js';
    import mutations from '../../vuex/contractor_history/mutation_types.js';
    import DocumentAllocations from "./document-details/DocumentAllocations";
    import AllocationsForDocument from "./document-details/AllocationsForDocument";
    import OperationAllocations from "./document-details/OperationAllocations";
    import DocumentCorrections from "./document-details/DocumentCorrections";
    import permissions from '../../services/Permissions.js';
    import HelpModal from '../help/HelpModal.vue';
    import ButtonOpenHelpModal from '../help/ButtonOpenHelpModal.vue';
    import axios from "axios";

    export default {
        name: 'document-history',
        components: {DocumentCorrections, OperationAllocations, AllocationsForDocument, DocumentAllocations, HelpModal, ButtonOpenHelpModal},
        mixins: [tooltips],
        data: function () {
            return {
                showDetails: null,
                ids: [],
                modalRemarksDocument: '',
                showAlsoTimelyChecked: false
            }
        },
        methods: {
            showAlsoTimely(event) {
                const isChecked = event.target.checked;

                const url = new URL(window.location.href);
                const params = url.searchParams;

                if (isChecked) {
                    params.set('show_also_timely', '1');
                } else {
                    params.delete('show_also_timely');
                }

                // Przekieruj na nowy URL
                window.location.href = url.toString();
            },
            checkCanEdit(v){
                const self = this;
                axios.post("check-access-to-department",{
                    payment_source: v.check_is_visible,
                    method:'edit',
                }).then(function(response) {
                    if(response.data.status == 'success'){
                        window.location = v.edit_url +'?&returnUrl=' + self.return_url
                    }
                    else{
                        swal( {
                            title: "",
                            text: response.data.message,
                            type: "warning",
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        })
                    }
                });
            },
            checkCanShow(v){
                const self = this;
                axios.post("check-access-to-department",{
                    payment_source: v.check_is_visible,
                    method:'show',
                }).then(function(response) {
                    if(response.data.status == 'success'){
                        window.location = v.show_url +'?&returnUrl=' + self.return_url
                    }
                    else{
                        swal( {
                            title: "",
                            text: response.data.message,
                            type: "warning",
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Ok",
                            closeOnConfirm: true
                        })
                    }
                });
            },
            hasAccessToDestroy(v){
                if(v.destroy_url && v.destroy_url != "" && v.destroy_url !== null){
                    if(v.destroy_url.includes('delete-generated-balance')){
                        return v.has_access_delete != undefined && v.has_access_delete;
                    }
                    if(v.destroy_url.includes('delete-compensation')){
                        return v.has_access_delete != undefined && v.has_access_delete
                    }
                }
                return false;
            },
            checkPermissionForDocumentToEdit(document){
                if(document.document_type_permission == null){
                    return document.has_access_edit_default;
                }
                else if(document.document_type_permission == 'pl'){
                    return document.has_access_edit_pl;
                }
                else if(document.document_type_permission == 'pl-basic'){
                    return document.has_access_edit_basic;
                }
            },
            handleDocumentSelect: function(document) {
                this.$emit('disableButtons')
                this.showDetails = '';
                if (event.target.checked) {
                   this.selectDocument(document);
                } else {
                   this.removeDocument(document);
                   this.removeSelectAll();
                }
            },
            removeSelectAll: function() {
                this.$refs['check_all'].checked  = false;
            },
            clickDisabledEditionIcon: function() {
                swal($.i18n._("warning_document_edition_has_been_disabled"));
            },
            selectDocument: function(document) {
                if(this.ids.indexOf(document.id) < 0) this.ids.push(document.id);
                this.$store.commit(mutations.ADD_SELECTED, document);
                this.$store.commit(mutations.SELECT_DOCUMENT, document.id);
            },
            removeDocument: function(document) {
                  if(this.ids.indexOf(document.id) >= 0) this.ids.splice(this.ids.indexOf(document.id), 1);
                  this.$store.commit(mutations.REMOVE_SELECTED, document);
                  this.$store.commit(mutations.REMOVE_DOCUMENT, document.id);
            },
            handleSelectAll: function() {
                if(event.target.checked) {
                    this.selectAll();
                } else if (!event.target.checked) {
                    this.clearSelected();
                }
            },
            clearSelected: function() {
                this.documents.forEach(document => {
                    this.removeDocument(document);
                })
            },
            selectAll: function() {
                this.documents.forEach(document => {
                    this.selectDocument(document);
                })
            },
            toggleDetails: function(index) {
                this.showDetails = (this.showDetails === index ? null : index);
            },
            documentStatusLabel: function(document) {
                return {
                    'label-black': document.status === 'rejected' || document.status === 'cancelled',
                    'label-danger': document.status === 'not_confirmed',
                    'label-gray': !['rejected', 'not_confirmed', 'cancelled'].includes(document.status)
                };
            },
            handleResponseSuccess: function(response) {
                if(response.data.message) toastr['success'](this.__(response.data.message)).css('border', '0px');

                this.$emit('change', {
                    props: this.$props,
                    message: response.data.message
                });
            },
            handleResponseFail: function(error) {
                console.log(error.response.data.message);
                toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
            },
            destroy: function(allocation) {
                this.detailsVisible = null;
                const _this = this;
                if(allocation.generated_balance){
                    swal({
                        title: $.i18n._('delete_record_?'),
                        text:$.i18n._('it_will_not_be_possible_to_retrieve_it_later_!'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: $.i18n._('delete'),
                        cancelButtonText: $.i18n._('cancel'),
                        closeOnConfirm: true,
                    }, function () {
                        _this.axios.delete(allocation.destroy_url)
                            .then(response => _this.handleResponseSuccess(response))
                            .catch(error => _this.handleResponseFail(error));
                    });
                }
                else{
                    swal({
                        title: $.i18n._('delete_allocation_?'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: $.i18n._('delete'),
                        cancelButtonText: $.i18n._('cancel'),
                        closeOnConfirm: true
                    }, function () {
                        _this.axios.delete(allocation.destroy_url)
                            .then(response => _this.handleResponseSuccess(response))
                            .catch(error => _this.handleResponseFail(error));
                    });
                }


            },
            goToPage: function(page) {
                this.$emit('paginate', {
                    per_page: this.meta.per_page,
                    page: page,
                    props: this.$props
                })
            },
            changePerPage: function(per_page) {
                this.$emit('paginate', {
                    per_page: per_page,
                    page: 1,
                    props: this.$props
                })
            },
            showRemarks: function(document) {
                event.stopPropagation();
                if(document.status === 'not_confirmed') {
                    this.modalRemarksDocument = document;
                    this.$refs['modal-document-remarks'].show();
                }
            },
            addEditPermission(document) {
                if(document.is_document_pl) {
                    return permissions.getPermission(this.permission_access, 'perm_menu_documents_pl_add') && permissions.getPermission(this.permission_access, 'adding_and_editing_documents')
                }
                return permissions.getPermission(this.permission_access, 'perm_menu_documents_add') && permissions.getPermission(this.permission_access, 'adding_and_editing_pl_documents')
            },
            getPermission: function(permission) {
                return permissions.getPermission(this.permission_access, permission);
            },
        },
        computed: {
            showRealPaymentInDays: function (){
                if(this.table_title == 'documents'){
                    return this.permission_access.perm_view_summaries_contractor_history_payments;
                }
              return true;
            },
            tableType: function () {
                if (this.table_title == "unallocated_documents") {
                    return "unallocated-documents";
                } else {
                    return "documents";
                }
            },
            location: function () {
                return location.pathname
            },
            isNotPaidAlert: function (){
                return this.$props.isNotPaidAlertProp ??   false
            },
            bulkUrl: function () {
                return this.$props.bulkActionUrl ?? '/summaries/contractor-history/' + this.contractor_id + '/bulk-action'
            },
            bulkIds: function () {
                return this.ids
            },
            userInfo: function () {
                return this.$store.getters.getUserInfo
            },
            tableTitle: function () {
                return this.$props.table_title ?? 'unallocated_documents'
            },
            bulkAdditionalData: function () {
                return this.$store.getters.getContractorHistoryGetParams(0);
            },
            contractorHistoryDocumentsExportDisabled: function () {
                const _this = this;
                let hasAccess = true;
                let checked = this.documents.filter(function (item) {
                    return _this.ids.includes(item.id)
                })
                if (checked.length == 0) {
                    this.documents.forEach(document => {
                        if (!document.has_access_export) {
                            hasAccess = false
                            return true;
                        }
                    })
                    return false;
                }
                checked.forEach(document => {
                    if (!document.has_access_export) {
                        hasAccess = false;

                    }
                })
                if (hasAccess) {
                    return false;
                } else {
                    return true;
                }
            },
        },
        mounted: function() {
            const reset = () => {
                this.clearSelected();
                if(this.$refs['check_all']) this.$refs['check_all'].checked = false
            };
            events.$on('modalConnectWith:saved', reset);
            events.$on('modalGenerateBalance:saved', reset);
            events.$on('modalConnectWith:hide', reset)
            const urlParams = new URLSearchParams(window.location.search);
            this.showAlsoTimelyChecked = urlParams.get('show_also_timely') === '1';
        },
        props: [
            'permission_access',
            'documents',
            'table_title',
            'contractor_id',
            'index',
            'paginate',
            'meta',
            'show_balance',
            'multiple_contractors',
            'show_due_date',
            'section_balance',
            'bulkActionUrl',
            'helpName',
            'allow_export',
            'return_url',
            'hide_balance_in_default_currency_row',
            'isNotPaidAlertProp'
        ],
    }
</script>

<style scoped>
    .document-line {
        border: 0;
    }
    .document-allocations {
        background-color: white;
    }

    .contractor-table-field{
        max-width: 100px;
    }

    .label-danger {
        cursor: pointer;
    }

    .modal-body {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .text-green {
        color: green;
    }

    .text-red {
        color: red;
    }

</style>
